import { ModelBase } from "./ModelBase.js";
import { LoraNetworkProfile } from "verdi-common/schemas/loraNetworkProfile/loraNetworkProfile.js";

export class ClientLoraNetworkProfile extends ModelBase {
    _lastJSON: LoraNetworkProfile;

    constructor(json) {
        super(json);
        this.dbID = json._id || json.id;
        this.category = "loraNetworkProfile";
        this.assignFromJSON(json);
        this.load();
    }

    assignFromJSON(json: LoraNetworkProfile) {
        super.assignFromJSON(json);
        this._lastJSON = json;
    }

    /**
     * Gets a simple object to represent this LoRa network profile.
     * @return {LoraNetworkProfile}
     */
    getJSON(): LoraNetworkProfile {
        return this._lastJSON;
    }
}
